export const SLIDER_HEIGHT = 81;
